let employeelist =  [
  {
    "fname": "Jayne",
    "lname": "Washington",
    "email": "jaynewashington@exposa.com",
    "title": "CEO",
    "country": "USA",
    "State": "San Francisco",
    "DOJ": "2nd January, 1919",
    "route": "/jaynewashington@exposa.com"
  },
  {
    "fname": "Peterson",
    "lname": "Dalton",
    "email": "petersondalton@exposa.com",
    "title": "CFO",
    "country": "USA",
    "State": "New York",
    "DOJ": "2nd January, 2019",
    "route": "/petersondalton@exposa.com"
  },
  {
    "fname": "Velazquez",
    "lname": "Calderon",
    "email": "velazquezcalderon@exposa.com",
    "title": "Director",
    "country": "USA",
    "State": "San Jose",
    "DOJ": "2nd January, 1819",
    "route": "/velazquezcalderon@exposa.com"
  },
  {
    "fname": "Norman",
    "lname": "Reed",
    "email": "normanreed@exposa.com",
    "title": "Manager - Marketting",
    "country": "USA",
    "State": "San Francisco",
    "DOJ": "2nd January, 1719",
    "route": "/normanreed@exposa.com"
  }
]
export default employeelist